"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const react_router_redux_1 = require("react-router-redux");
const constants_1 = require("../constants");
const LoadingSpinner_1 = require("../shared/LoadingSpinner");
const AuthenticationActions_1 = require("../authentication/AuthenticationActions");
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        push: path => dispatch(react_router_redux_1.push(path)),
        loginSuccess: data => dispatch(AuthenticationActions_1.loginSuccess(data))
    };
}
function mapStateToProps(state = constants_1.INITIAL_STATE) {
    return {
        authentication: state.authentication
    };
}
class RedirectToOrganizationRouteComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            state: constants_1.ProgressState.Loading
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.props.authentication && this.props.authentication.organization && this.props.authentication.organization.routePrefix && !this.props.authentication.organization.marker) {
                    window.location.replace(`/${this.props.authentication.organization.routePrefix}${this.props.location.pathname}`);
                    return;
                }
                setTimeout(() => {
                    if (this.props.authentication && this.props.authentication.organization && this.props.authentication.organization.routePrefix && !this.props.authentication.organization.marker) {
                        window.location.replace(`/${this.props.authentication.organization.routePrefix}${this.props.location.pathname}`);
                    } else {
                        window.location.replace('/');
                    }
                }, 1000);
            } catch (err) {
                return this.props.push(constants_1.ROUTES.Landing);
            }
        });
    }
    render() {
        return React.createElement("div", { className: "full-center-cont" }, React.createElement(LoadingSpinner_1.default, null));
    }
}
const RedirectToOrganizationRoute = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(RedirectToOrganizationRouteComponent);
exports.default = RedirectToOrganizationRoute;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/RedirectToOrganizationRoute.tsx
// module id = 1352
// module chunks = 0 1